<template>
  <div class="app">
    <el-form :inline="true" class="demo-form-inline">
      <el-form-item label="客户名称">
        <el-input v-model.trim="params.cmName" size="mini" :maxlength="$store.state.inputLength"></el-input>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" size="mini" @click="searchData">查询</el-button>
      </el-form-item>

    </el-form>
    <div>
      <el-table stripe :header-cell-class-name="headerStyle" :data="data.list" height="300" border style="width: 100%"
        highlight-current-row size="mini" @row-dblclick="ondblclick" @row-click="onclick">
        <!-- 主表单 -->
        <el-table-column v-for="(item, index) in data.name" :key="index" :prop="item.prop" :label="item.label"
          show-overflow-tooltip :min-width="item.minWidth"></el-table-column>
        <el-table-column fixed="right" label="操作" width="110">
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click.stop="handleSelectClick(scope.row)">确认选择</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div class="page_content_bottom">
        <el-pagination background @size-change="setDataPageSize" @current-change="setDataPageNumber"
          :current-page="params.page" :page-sizes="[30, 50, 100, 500]" :page-size="params.rows"
          layout="total, sizes, prev, pager, next, jumper" :total="data.obj.total">
        </el-pagination>
      </div>
    </div>
    <div class="children">
      <el-table stripe :header-cell-class-name="headerStyle" :data="childDate.list" height="300" border
        style="width: 100%" highlight-current-row size="mini">
        <!-- 主表单 -->
        <el-table-column v-for="(item, index) in childDate.name" :key="index" :prop="item.entityField"
          :label="item.showField" show-overflow-tooltip :min-width="item.minWidth">
          <template slot-scope="scope">
            <span v-if="item.fieldType == 'date'">{{ $common.getLocalTime(scope.row[item.entityField]) }}</span>
            <!-- <el-image class="el_image" v-for="(val,i) in scope.row.uploadVoList" :key="i" :src="getImgUrl(val.fileUrl)" :preview-src-list="[imgUrl+val.fileUrl]"></el-image> -->
            <div v-else-if="item.entityField == 'uploadVoList'" class="uploadList">
              <el-image class="image" v-for="(val, key) in scope.row.uploadVoList" :key="key"
                style="width: 20px; height: 20px" :src="imgUrl + '/' + val.fileUrl"
                :preview-src-list="[imgUrl + '/' + val.fileUrl]">
              </el-image>
            </div>
            <span v-else>{{ scope.row[item.entityField] }}</span>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
//cusmasterqueryMpcus
export default {
  name: "ExtractionCustomer",
  data() {
    return {
      imgUrl: "",
      params: {
        cmName: "",
        page: 1,
        rows: 30
      },
      data: {
        list: [],
        name: [
          {
            prop: "cmName",
            label: "客户名称",
            minWidth: 200
          },
          {
            prop: "cmHemcode",
            label: "助记码",
            minWidth: 100
          },
          {
            prop: "cmLegalperson",
            label: "法定代表人",
            minWidth: 150
          },
          {
            prop: "cmIntype",
            label: "单位类型",
            minWidth: 100
          }, {
            prop: "cmHemcode",
            label: "助记码",
            minWidth: 100
          },
          {
            prop: "cmSocialcode",
            label: "统一社会信用码",
            minWidth: 100
          },
          {
            prop: "cmRegmoney",
            label: "注册资金",
            minWidth: 100
          },
          {
            prop: "cmBank",
            label: "开户行",
            minWidth: 150
          },
          {
            prop: "cmBankaccount",
            label: "银行账号",
            minWidth: 150
          },
          {
            prop: "cmRegaddres",
            label: "注册地址",
            minWidth: 100
          },
          {
            prop: "cmPhone",
            label: "联系电话",
            minWidth: 100
          },

        ],
        obj: {
          total: 0
        }
      },
      childDate: {
        list: [],
        name: []
      },
    }
  },
  computed: {
    getImgUrl(item) {
      return (data) => {
        console.log(this.$store.getters.getConfig.imgUrl + data);
        return this.$store.getters.getConfig.imgUrl + '2023-05-25/02b34b5f8f9b43768d0abe8b65451ecc.jpg'
      };
    },
  },
  created() {
    // this.openBox()
  },
  methods: {
    //图片地址转换
    pictureShow(data) {
      var imgList = [];
      data.forEach((item) => {
        imgList.push(this.imgUrl + "/" + item.fileUrl);
      });
      return imgList;
    },
    onclick(row) {
      this.initDetails(row.mcmId)
    },
    ondblclick(row, column, event) {
      this.initDetails(row.mcmId)
    },
    openBox(tabForm) {
      this.imgUrl = this.$store.getters.getConfig.imgUrl
      this.childDate.name = tabForm[1].jurconfigform
      this.childDate.name.forEach(item => {
        if (item.entityField == 'uploadVoList') {
          item.minWidth = 300
        } else {
          item.minWidth = 100
        }
      })
      this.$nextTick(() => {
        this.init()
      })
    },
    handleSelectClick(rows) {
      this.initDetails(rows.mcmId, true)
    },
    async init() {
      const responseData = await this.$http.cusmasterqueryMpcus(this.params)
      if (responseData.status == 200) {
        this.data.list = responseData.result.list
        this.data.obj.total = responseData.result.total
        if (this.data.list.length > 0) {
          this.initDetails(this.data.list[0].mcmId)
        }
      }
    },
    async initDetails(val, flag) {
      const params = {
        ids: [val]
      }
      const responseData = await this.$http.cusmasterqueryMpcusInfo(params)
      if (responseData.status == 200) {
        console.log(responseData.result.cuslicencelinfos);
        
         this.childDate.list = responseData.result.cuslicencelinfos
        if (flag) {
          this.$emit("TranData", responseData.result);
        }
      }
    },
    searchData() {
      console.log(this.childDate);
      this.params.page = 1
      this.init()
    },
    // 数据翻页
    setDataPageNumber(val) {
      this.params.page = val;
      this.init();
    },

    // 切换显示条数
    setDataPageSize(val) {
      this.params.page = 1;
      this.params.rows = val;
      this.init();
    },
    headerStyle({ row, column, rowIndex, columnIndex }) {
      return 'tableStyle'
    }
  },
}
</script>
<style scoped>
.img {
  height: 100px;
}

.el_image {
  height: 50px;
}

.uploadList {
  display: flex;
  align-items: center;
  flex-wrap: wrap;
}

.image {
  margin-right: 5px;
}
</style>
<style>
.tableStyle {
  background-color: #f5f7fa !important;
  border: 1px solid #ebeef5;
  color: #fff;
  font-weight: 400;
  height: 50px;
}
</style>